import type { ReactNode } from 'react';
import { cx } from './cx';

/** idsk/components/warning-text (`type: 'info'` → idsk-warning-text--info). */
export function WarningText({ type, className, lang, children }: { type?: 'info'; className?: string; lang?: string; children: ReactNode }) {
  return (
    <div className={cx('idsk-warning-text', type && `idsk-warning-text--${type}`, className)} lang={lang}>
      <div className="govuk-width-container">
        <div className="idsk-warning-text__text">{children}</div>
      </div>
    </div>
  );
}
